import * as Yup from 'yup'

import { getHeadlineShape, urlValidation } from '../../../../features/validations/other'

import {
  LONG_HEADLINES_LIST,
  longHeadlineMaxLength,
  VIDEO_ADS_ENTER,
  VIDEO_ADS_OPTION,
  VIDEO_ADS_URL,
  youtubeVideoIdUrlParams
} from '../fields'
import { generalGoogleAdValidation } from '../validations'

export const longHeadlineShape = getHeadlineShape(longHeadlineMaxLength)

export const linkItemShape = Yup.object({
  text: urlValidation.test(
    'link',
    'Youtube video link must contain video id',
    link => link?.includes(youtubeVideoIdUrlParams) || link?.includes('youtu.be/')
  )
})

export const validationSchema = Yup.object({
  ...generalGoogleAdValidation,
  [LONG_HEADLINES_LIST]: Yup.array().of(longHeadlineShape),
  [VIDEO_ADS_URL]: Yup.array().when(VIDEO_ADS_OPTION, {
    is: VIDEO_ADS_ENTER,
    then: () => Yup.array().of(linkItemShape)
  })
})
